<template>
  <div class="media-card mb-3">
    <div class="d-flex align-items-center inner">
      <div class="flex-grow-1">
        <a href="#" @click.prevent="downloadFile"><b class="media-name">{{ file.file_name }}</b></a>
      </div>
      <div class="flex-shrink-1">
        <b-dropdown variant="white" right toggle-class="text-muted pt-0 pr-0 mt-2">
          <template v-slot:button-content>
            <i class="mdi mdi-dots-horizontal font-size-18"></i>
          </template>
          <b-dropdown-item @click="downloadFile">Download</b-dropdown-item>
          <b-dropdown-item @click="requestDeleteFile" variant="danger">Delete</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import {mapGetters, mapActions} from "vuex";
import Forms from "../../../../../mixins/Forms";

export default {
  name: "File",
  components: {},
  props: ['file'],
  mixins: [Forms],

  methods: {
    ...mapActions('ticketViewer', {
      loadMedia: 'loadMedia'
    }),

    downloadFile() {
      window.open(this.file.url);
    },

    requestDeleteFile() {
      let vm = this;
      swal({
        title: "Are you sure you want to delete this file?",
        icon: "warning",
        buttons: {
          cancel: true,
          confirm: "Delete"
        },
        dangerMode: true,
      }).then((shouldDelete) => {
        if (shouldDelete) {
          vm.deleteFile();
        }
      });
    },

    deleteFile() {
      let vm = this;
      vm.isSaving = true;
      axios.delete(API_BASE + '/tickets/' + this.ticket.id + '/media/' + vm.file.id).then(r => {
        vm.isSaving = false;
        vm.loadMedia();
        this.$notify.success({
          title: 'Success!',
          message: 'File deleted successfully'
        });
      }).catch(e => {
        vm.isSaving = false;
        vm.notifyErrors(e);
      });
    }
  },

  computed: {
    ...mapGetters('ticketViewer', {
      ticket: 'ticket'
    })
  }
}
</script>

<style scoped lang="scss">
.media-card {
  background: #fff;
  border-radius: 5px;

  .media-name {
    font-weight: 600;
    color: #2c5cc5;
    max-width: 100%;
    word-wrap: anywhere;
  }

  .inner {
    padding-left: 15px;
    padding-right: 15px;
  }
}
</style>
